// Reprend l'état du widget « Votre événement en deux questions » dans le formulaire CF7 de la
// modale de privatisation : son CTA (templates/vue-apps/event-planner/index.vue.twig) porte le
// format, la salle recommandée et le nombre de convives en data-attributes, qu'on recopie dans les
// champs à l'ouverture. Les <option> de requester_event et requester_room reprennent au mot près
// les libellés du widget (formulaire CF7 « Privatisation »), d'où l'affectation directe.
const MODAL_SELECTOR = '#privatisation-modal'

const FIELD_NAME_BY_DATASET_KEY = {
  event: 'requester_event',
  room: 'requester_room',
  pax: 'requester_people'
}

const prefillPrivatisationModal = () => {
  const modal = document.querySelector(MODAL_SELECTOR)
  if (!modal) {
    return
  }

  // Bootstrap émet ses événements sur la modale elle-même : peu importe que le module bsModal,
  // chargé à l'apparition, arrive après nous.
  modal.addEventListener('show.bs.modal', (event) => {
    const trigger = event.relatedTarget
    if (!trigger) {
      return
    }

    Object.entries(FIELD_NAME_BY_DATASET_KEY).forEach(([datasetKey, fieldName]) => {
      const value = trigger.dataset[datasetKey]
      const field = modal.querySelector(`[name="${fieldName}"]`)
      if (field && value) {
        field.value = value
      }
    })
  })

  // Format, salle et nombre de convives arrivent du widget : le premier champ à saisir est le nom.
  modal.addEventListener('shown.bs.modal', () => {
    const nameField = modal.querySelector('[name="requester_name"]')
    if (nameField) {
      nameField.focus()
    }
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', prefillPrivatisationModal)
} else {
  prefillPrivatisationModal()
}
